import * as Phaser from "phaser";
import { BootScene } from "./scenes/boot-scene";
import { GameScene } from "./scenes/game-scene";
import { HUDScene } from "./scenes/hud-scene";
import { MenuScene } from "./scenes/menu-scene";
import * as GameData from "./assets/data/game_data";
import { SDKManager } from "./lib/SDKManager"
import Game from './game';

let parent = document.getElementById("game");
let height = parent.offsetHeight;
let width = parent.offsetWidth;
// let hdFlag = (width > 300);

declare global {
  interface Window { constants: any; game: Game; sdkManager: any }
}

// must move all these constants into game object in the future
window.constants = {};
window.constants["HD_FLAG"] = (width > 300);

let currentRatio = width / height;
let baseRatio = 1080 / 1920;
window.constants["MOBILE_FLAG"] = false;
if (currentRatio > 0.7) {
  width = height * baseRatio;
  parent.style.width = width + "px";
  parent.classList.add("al-c-h");
} else {
  window.constants["MOBILE_FLAG"] = true;
}

// let carChoosen = localStorage.getItem("hammerplay_rampageroad_car_equipped");
// if (carChoosen == null) {
//   localStorage.setItem("hammerplay_rampageroad_car_equipped", "0");
//   carChoosen = "0";
// }
// window.constants["CAR_CHOOSEN"] = Number(carChoosen);
// SDKManager.getPlayerCarEquippedMetaData();
// window.constants["CAR_CHOOSEN"] = SDKManager.carEquipped;
window.constants["CAR_CHOOSEN"] = 0;

// let mapChoosen = localStorage.getItem("hammerplay_rampageroad_map_equipped");
// if (mapChoosen == null) {
//   localStorage.setItem("hammerplay_rampageroad_map_equipped", "0");
//   mapChoosen = "0";
// }
// window.constants["MAP"] = Number(mapChoosen);
// SDKManager.getPlayerMapEquippedMetaData();
// window.constants["MAP"] = SDKManager.mapEquipped; // getRandomInt(3);
window.constants["MAP"] = 0;

window.constants["SDK"] = null;
window.constants["DATA"] = GameData;
window.constants["DATA"].speed = (window.constants["HD_FLAG"]) ? GameData.speed.HD : GameData.speed.SD;
window.constants["DATA"].rateOfFire = (window.constants["HD_FLAG"]) ? GameData.rateOfFire.HD : GameData.rateOfFire.SD;
window.constants["DATA"].rateOfRounds = (window.constants["HD_FLAG"]) ? GameData.rateOfRounds.HD : GameData.rateOfRounds.SD;
window.constants["RATIO"] = height / width;
window.constants["SOURCE_WIDTH"] = (window.constants["HD_FLAG"]) ? 1080 : 240;
window.constants["SOURCE_HEIGHT"] = (window.constants["HD_FLAG"]) ? 2686 : 340;
window.constants["BASE_WIDTH"] = (window.constants["HD_FLAG"]) ? Math.floor(1080 / 1.15) : Math.floor(240 / 1.15);
window.constants["BASE_HEIGHT"] = Math.floor(window.constants["BASE_WIDTH"] * window.constants["RATIO"]);
window.constants["SCREEN_WIDTH"] = (window.constants["HD_FLAG"]) ? 1080 : 240;
window.constants["SCREEN_HEIGHT"] = Math.floor(window.constants["SCREEN_WIDTH"] * window.constants["RATIO"]);
window.constants["DEAD_SPOT"] = {
  x: Math.floor(window.constants["BASE_HEIGHT"] + Math.round(window.constants["BASE_HEIGHT"] * 0.5)),
  y: Math.floor(window.constants["BASE_WIDTH"] + Math.round(window.constants["BASE_WIDTH"] * 0.5))
}
window.constants["GAME_START"] = false;
window.constants["GAME_OVER"] = false;
window.constants["FUEL_TRUCK_BLAST"] = false;
window.constants["VOLUME"] = 0.5;
window.constants["TOUCH_FLAG"] = false;
window.constants["POINTS"] = [];
window.constants["UPDATE_POINTS"] = false;
window.constants["OBJECT_SCALE"] = (window.constants["HD_FLAG"]) ? 1 : 0.8;
window.constants["CAMERA_BOUND"] = -Math.floor(((window.constants.SCREEN_WIDTH) - window.constants.BASE_WIDTH) / 2);

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

const config: Phaser.Types.Core.GameConfig = {
  title: "Rampage Road",
  version: "1.0",
  width: parent.offsetWidth,
  height: parent.offsetHeight,
  // zoom: 1,
  type: Phaser.AUTO,
  parent: "game",
  scene: [BootScene, MenuScene, GameScene, HUDScene],
  input: {
    keyboard: true,
    gamepad: false,
    mouse: true,
    windowEvents: false,
    touch: true
  },
  physics: {
    default: "arcade",
    arcade: {
      x: 0,
      y: 0,
      width: window.constants.BASE_WIDTH,
      height: window.constants.BASE_HEIGHT,
      gravity: { x: 0, y: 0 },
      debug: false,
      fps: (window.constants["HD_FLAG"]) ? 60 : 60,
      useTree: true,
    }
  },
  scale: {
    mode: Phaser.Scale.WIDTH_CONTROLS_HEIGHT,
    height: window.constants.SCREEN_HEIGHT,
    width: window.constants.BASE_WIDTH,
    autoRound: true,
  },
  autoRound: true,
  roundPixels: true,
  backgroundColor: "#0b1636",
  fps: {
    smoothStep: true,
    target: (window.constants["HD_FLAG"]) ? 60 : 60,
    min: (window.constants["HD_FLAG"]) ? 30 : 30,
  },
  banner: true // show the phaser version in console
};

function _initGame() {
  window.game = new Game(config);
  window.constants["SDK"] = new SDKManager();
  window.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      window.game.sound.mute = true;
    } else {
      window.game.sound.mute = false;
    }
  })
}

window.addEventListener("load", () => {
  _initGame();
  setTimeout(handleResize);
  // Add resize event listener with debouncing
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize);
  });

  // Also handle orientation change for mobile
  window.addEventListener("orientationchange", () => {
    setTimeout(handleResize);
  });

  function handleResize() {
  if (!window.game) return;

  const parent = document.getElementById("game");
  const newHeight = window.innerHeight;
  const newWidth = window.innerWidth;

  // Update parent dimensions
  parent.style.height = newHeight + "px";
  parent.style.width = newWidth + "px";

  // Recalculate constants
  window.constants["HD_FLAG"] = (newWidth > 300);

  let currentRatio = newWidth / newHeight;
  let baseRatio = 1080 / 1920;
  window.constants["MOBILE_FLAG"] = false;

  let finalWidth = newWidth;
  let finalHeight = newHeight;

  if (currentRatio > 0.7) {
    finalWidth = Math.floor(newHeight * baseRatio);
    parent.style.width = finalWidth + "px";
    parent.classList.add("al-c-h");
    window.constants["MOBILE_FLAG"] = false;
  } else {
    parent.style.width = "100%";
    parent.classList.remove("al-c-h");
    window.constants["MOBILE_FLAG"] = true;
  }

  // Update all constants with new dimensions
  window.constants["RATIO"] = finalHeight / finalWidth;
  window.constants["BASE_WIDTH"] = (window.constants["HD_FLAG"]) ? Math.floor(1080 / 1.15) : Math.floor(240 / 1.15);
  window.constants["BASE_HEIGHT"] = Math.floor(window.constants["BASE_WIDTH"] * window.constants["RATIO"]);
  window.constants["SCREEN_WIDTH"] = (window.constants["HD_FLAG"]) ? 1080 : 240;
  window.constants["SCREEN_HEIGHT"] = Math.floor(window.constants["SCREEN_WIDTH"] * window.constants["RATIO"]);

  // Update physics world
  if (window.game.physics && window.game.physics.world) {
    window.game.physics.world.setBounds(0, 0, window.constants.BASE_WIDTH, window.constants.BASE_HEIGHT);
  }

  // Properly resize the game
  window.game.scale.setGameSize(window.constants.BASE_WIDTH, window.constants.SCREEN_HEIGHT);
  window.game.scale.refresh();

  // Update camera bounds for all scenes
  window.game.scene.scenes.forEach(scene => {
    if (scene.cameras && scene.cameras.main) {
      scene.cameras.main.setBounds(0, 0, window.constants.BASE_WIDTH, window.constants.BASE_HEIGHT);
    }
  });
}
});